// useUtilityFunctions.js

// Cache busting version for map image - increment this when the map image is updated
export const MAP_IMAGE_VERSION = '20251029';

export function useFormatPrice() {
    const formatPrice = (price) => {
        if (typeof price !== 'number') {
            return price;
        }
        const formatter = new Intl.NumberFormat('nl-NL', {
            style: 'currency',
            currency: 'EUR',
        });
        return formatter.format(price);
    };
    return { formatPrice };
}

export function useDebounce() {
    const debounce = (func, wait) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(this, args);
            }, wait);
        };
    };
    return { debounce };
}

export function formatWebsiteUrl(website) {
    if (!website || !website.trim()) {
        return '';
    }
    
    const trimmed = website.trim();
    
    // Check if URL already has a protocol
    if (trimmed.match(/^https?:\/\//i)) {
        return trimmed;
    }
    
    // If no protocol, prepend https://
    return 'https://' + trimmed;
}
